import fclone from 'fclone';
function _mergeFields(target, source) {
    const targetCopy = fclone(target);
    targetCopy.fields = Object.keys(source.fields).reduce((memo, key) => {
        if (Object.prototype.hasOwnProperty.call(memo, key)) {
            throw new Error(`Duplicated key "${key}" found when merging entities of type "${target.typeName}"`);
        }
        return Object.assign(Object.assign({}, memo), { [key]: source.fields[key] });
    }, targetCopy.fields);
    return targetCopy;
}
export function mergeEntities(...entities) {
    return entities.reduce((memo, entity) => {
        const { typeName } = entity;
        if (typeName == null) {
            console.error('No typeName found for entity', entity);
            throw new Error('No typeName found for entity');
        }
        const existingEntity = memo[typeName];
        if (existingEntity == null) {
            return Object.assign(Object.assign({}, memo), { [typeName]: entity });
        }
        return Object.assign(Object.assign({}, memo), { [typeName]: _mergeFields(existingEntity, entity) });
    }, {});
}
//# sourceMappingURL=merge-entities.js.map